import { render, staticRenderFns } from "./vacaAdd.vue?vue&type=template&id=0bf5c988&scoped=true"
import script from "./vacaAdd.vue?vue&type=script&lang=js"
export * from "./vacaAdd.vue?vue&type=script&lang=js"
import style0 from "./vacaAdd.vue?vue&type=style&index=0&id=0bf5c988&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bf5c988",
  null
  
)

export default component.exports